window.addEventListener('px-ready',function(){
    //console.log('x');
    document.querySelectorAll('.px-project-list.checkfordupes > span').forEach(function(item){
        item.addEventListener('mouseenter',function(event){
            addHover(item.getAttribute('data-col1'),item.getAttribute('data-col2'),item.getAttribute('data-col3'))
        })
        item.addEventListener('mouseleave',function(event){
            removeHover();
        })
        //console.log(item.getAttribute('data-col1') + ' ' + item.getAttribute('data-prevcol1'))
        if(item.getAttribute('data-col1') == item.getAttribute('data-prevcol1')){
            //item.querySelector('.col1').classList.add('uk-invisible@m');
            item.querySelector('.col1').classList.add('removed');
        }
        if(item.getAttribute('data-col2') == item.getAttribute('data-prevcol2')){
            //item.querySelector('.col1').classList.add('uk-invisible@m');
            item.querySelector('.col2').classList.add('removed');
        }
        if(item.getAttribute('data-col3') == item.getAttribute('data-prevcol3')){
            //item.querySelector('.col1').classList.add('uk-invisible@m');
            item.querySelector('.col3').classList.add('removed');
        }
    })
})

function addHover(col1,col2,col3){
    window.setTimeout(function(){
        document.querySelectorAll('.px-project-list')[0].setAttribute('data-col1',col1);
        document.querySelectorAll('.px-project-list')[0].setAttribute('data-col2',col2);
        document.querySelectorAll('.px-project-list')[0].setAttribute('data-col3',col3);
        figureOutHover();
    },30);
}
function removeHover(){
    document.querySelectorAll('.px-project-list')[0].setAttribute('data-col1','');
    document.querySelectorAll('.px-project-list')[0].setAttribute('data-col2','');
    document.querySelectorAll('.px-project-list')[0].setAttribute('data-col3','');
    figureOutHover();
}
function figureOutHover(){
    let col1 = document.querySelectorAll('.px-project-list')[0].getAttribute('data-col1');
    let col2 = document.querySelectorAll('.px-project-list')[0].getAttribute('data-col2');
    let col3 = document.querySelectorAll('.px-project-list')[0].getAttribute('data-col3');
    //console.log(col1 + ' ' + col2 + ' ' + col3); 
    document.querySelectorAll('.px-project-list > span').forEach(function(item){
        if(item.getAttribute('data-col1') === col1){
            item.classList.add('hover');
        }else if(item.getAttribute('data-col2') === col2){
            item.classList.add('hover');
        }else if(item.getAttribute('data-col3') === col3){
            item.classList.add('hover');
        }else{
            item.classList.remove('hover');
        }
    })
}